/*
* @Author: yongwenhao
* @Date: 2020-04-13 09:33:20
* @describe: 官网接口
*/
import axios from './http'

//查询轮播图列表
export const GetPublicView = params => {
    return axios.get("/public/view", {params});
};
// 查询book列表
export const GetBookList = params => {
    return axios.get("/public/book", {params});
};
// 查询news列表
export const GetNewList = params => {
    return axios.get("/public/news", {params});
};
// 查询领导人信息
export const GetLeaderList = params => {
    return axios.get("/public/leader", {params});
};
// 添加合作表单
export const PostCooperate = params => {
    return axios.post("/public/cooperate", params);
};
//获取book详情
export const GetBookInfo = bookId => {
    return axios.get(`/public/book/${bookId}`);
};
//获取新闻详情
export const GetNewsInfo = newsId => {
    return axios.get(`/public/news/${newsId}`);
};
// 查询职位列表
export const GetPositionsList = params => {
    return axios.get("/positions/publish", {params});
};
// 申请职位
export const PostApplicantInfo = params => {
    return axios.post("/applicantInfo/add", params, {
        headers: {'Content-Type': 'multipart/form-data'}
    });
};
// 获取职位详情
export const GetPositionsInfo = positionId => {
    return axios.get(`/positions/get/${positionId}`);
};
// 获取职位详情
export const GetWelfareInfo = () => {
    return axios.get(`/positions/welfare`);
};